<template>
    <div class="personalMain">
      <p class="current">当前位置：<span>{{ name }}</span></p>
      <div class="personal-box">
        <!-- <personalMenu></personalMenu> -->
        <div class="MainInfo">
            <div class="address-info">
                <el-form :model="ruleForm"  ref="ruleForm" label-width="160px">
                    <el-form-item label="联系人：">
                        <el-input v-model="ruleForm.contact" placeholder="请填写联系人姓名" ></el-input>
                    </el-form-item>
                    
                    <el-form-item label="手机号：">
                        <el-input v-model="ruleForm.phone" placeholder="请填写手机号码"></el-input>
                    </el-form-item>
                
                    <el-form-item label="省市区：" >
                        <!-- {{ itemsList.province_name }}  {{ itemsList.city_name }}  {{ itemsList.county_name }} -->
                        <!-- <el-input placeholder="请选择省市区"  type="password" ></el-input> -->
                        <v-distpicker :placeholders="placeholders"
                                        @province="onChangeProv"
                                        @city="onChangeCity"
                                        @area="onChangeArea"></v-distpicker>
                    </el-form-item>
                    <el-form-item label="地址：" >
                        <el-input v-model="ruleForm.address" placeholder="请填写详细地址" ></el-input>
                        
                    </el-form-item>
                    <el-form-item label="同步到发货地址：" v-if="types == 1">
                        <el-switch
                            v-model="ruleForm.sync"
                            active-color="#007aff"
                            inactive-color="#f2f2f2"
                            active-value="1"
                            inactive-value="0"
                        >
                    </el-switch>
                    </el-form-item>
                    <el-form-item label="默认常用地址：">
                        <el-switch
                            v-model="ruleForm.is_default"
                            active-color="#007aff"
                            inactive-color="#f2f2f2"
                            active-value="1"
                            inactive-value="0"
                        >
                    </el-switch>
                    </el-form-item>
                    <el-form-item style="border: none;">
                        <el-button type="primary" class="restButtonForget" @click="updateAddress">提交并保存</el-button>
                    </el-form-item>
                </el-form>

            </div>
        
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import VDistpicker from 'v-distpicker'
  export default {
    data(){
      return{
        name: '',
        ruleForm: {
            contact: '',
            phone: '',
            address: '',
            sync: 0,
            is_default: 0,
            
        },
        addressInfo: {},
        placeholders: {
            province: '请选择省份',
            city: '请选择市区',
            area: '请选择县城或区',
        },
        addressList: {
            province_name: '',
            province_code: '',
            city_name: '',
            city_code: '',
            county_name: '',
            county_code: '',
        },
        types: '',
        placeName: '请填写联系人姓名',
        itemsList: ''
      }
    },
    components:{
        VDistpicker
    },
    methods: {
        handleActive(val){
            this.active = val
        },
        onChangeProv (e) {
            console.log("省", e);
            this.addressList.province_name = e.value
            this.addressList.province_code = e.code
            this.addressList.city_name = ''
            this.addressList.city_code = ''
            this.addressList.county_name = ''
            this.addressList.county_code = ''
        },
        onChangeCity (e) {
            console.log("市", e);
            this.addressList.city_name = e.value
            this.addressList.city_code = e.code
            this.addressList.county_name = ''
            this.addressList.county_code = ''
        },
        onChangeArea (e) {
            console.log("县", e);
            this.addressList.county_name = e.value
            this.addressList.county_code = e.code
        },
        updateAddress(){
            console.log( this.ruleForm.sync+ ';'+ this.ruleForm.is_default);
            if(this.addressList.city_name == ''){
                this.$alert('请选择市区','提示',{
                    confirmButtonText: '确定',
                })
            }else if(this.addressList.county_name == ''){
                this.$alert('请选择区','提示',{
                    confirmButtonText: '确定',
                })
            }else if(this.ruleForm.address == ''){
                this.$alert('请填写详细地址','提示',{
                    confirmButtonText: '确定',
                })
            }else if(this.ruleForm.contact == ''){
                this.$alert('请填写联系人名称','提示',{
                    confirmButtonText: '确定',
                })
            }else if(this.ruleForm.phone == ''){
                this.$alert('请填写手机号码','提示',{
                    confirmButtonText: '确定',
                })
            }else if(this.$route.query.id != '-1'){ // 修改
                let data = {
                    address: this.ruleForm.address,
                    city_code: this.addressList.city_code,
                    city_name: this.addressList.city_name,
                    contact: this.ruleForm.contact,
                    county_code: this.addressList.county_code,
                    county_name: this.addressList.county_name,
                    id: this.$route.query.id,
                    phone: this.ruleForm.phone,
                    province_code: this.addressList.province_code,
                    province_name: this.addressList.province_name,
                    sync: this.ruleForm.sync,
                    is_default: this.ruleForm.is_default
                }
                this.$store.dispatch('personal/addressUpdate',data)
                    .then(res => {
                        if(res.ok){
                            this.$notify({
                                title: '提示',
                                message: '修改成功',
                                type: 'success'
                            })
                            this.$router.push({
                                path: '/uconfigInvoice'
                            })
                        }
                    })
            }else{ // 添加
                let data = {
                    address: this.ruleForm.address,
                    city_code: this.addressList.city_code,
                    city_name: this.addressList.city_name,
                    contact: this.ruleForm.contact,
                    county_code: this.addressList.county_code,
                    county_name: this.addressList.county_name,
                    phone: this.ruleForm.phone,
                    province_code: this.addressList.province_code,
                    province_name: this.addressList.province_name,
                    sync: this.ruleForm.sync,
                    is_default: this.ruleForm.is_default
                }
                this.$store.dispatch('personal/addInvoiceAddress',data)
                    .then(res => {
                        if(res.ok){
                            this.$notify({
                                title: '提示',
                                message: '添加成功',
                                type: 'success'
                            })
                            this.$router.push({
                                path: '/uconfigInvoice'
                            })
                        }
                    })
            }
        }


    },
    mounted(){
        
    },
    created(){
        this.name = this.$route.query.name
        this.types = this.$route.query.id
        if(this.$route.query.id != '-1'){ //修改
            let data = {
                id: this.$route.query.id
            }
            this.$store.dispatch('personal/addressInfo',data)
                .then(res => {
                    if(res.ok){
                        this.ruleForm = {
                            contact : res.data.contact,
                            phone : res.data.phone,
                            address : res.data.address,
                            is_default: res.data.is_default,
                        }
                        this.addressList = {
                            province_name: res.data.province_name,
                            province_code: res.data.province_code,
                            city_name: res.data.city_name,
                            city_code: res.data.city_code,
                            county_name: res.data.county_name,
                            county_code: res.data.county_code,


                        }

                        this.itemsList = res.data
                        // this.placeholders = {
                        //         province: '请选择省份',
                        //         city: '请选择市区',
                        //         area: '请选择县城或区',
                        //         province: res.data.province_name,
                        //         city: res.data.city_name,
                        //         area: res.data.county_name,
                        // }
       
                        
                    }
                })
        }
    }
  }
  </script>
  
<style>
@import url(../../../css/personal.css);
.distpicker-address-wrapper select{
  
    width: 150px !important;
    padding: 0px 10px !important;
    height: 40px !important;
    font-size: 15px !important;
    line-height: 30px !important;
    border-radius: 0;
    border: none;

}

</style>
<style>
.address-info .el-input__inner{
    border: none;
}
.address-info .el-form-item {
    margin-bottom: 40px;
    padding-bottom: 16px;
    border-bottom: 0.5px solid #f2f2f2;
}
.address-info .el-form-item__error{
    padding-left: 15px;
}
</style>
<style scoped>
.MainInfo{
    width: 1200px;
    margin: 0 auto;
}
.MainInfo .address-info{
    width: 770px;
    margin: 20px auto;
}
.MainInfo .address-info .el-input{
    width: 488px;
    height: 42px;
}

.restButtonForget{
   width: 232px;height: 40px;
   background: #4095e5;
   color: #ffffff;
   border: 1px solid #4095e5;
   margin-top: 20px;
   align-items: center;
}


</style>